"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFieldVisibilityContext = exports.FieldVisibilityProvider = void 0;
const React = __importStar(require("react"));
const useWhyDidYouUpdate_1 = require("../useWhyDidYouUpdate");
const lodash_1 = __importDefault(require("lodash"));
const FieldVisibilityStateContext = React.createContext(undefined);
const FieldVisibilityDispatchContext = React.createContext(undefined);
const reducer = (state, action) => {
    const newSettings = action.payload;
    switch (action.type) {
        case "update": {
            return lodash_1.default.isEqual(newSettings, state) ? state : newSettings;
        }
        default:
            throw new Error();
    }
};
exports.FieldVisibilityProvider = ({ value, children }) => {
    const [state, dispatch] = React.useReducer(reducer, value);
    return (React.createElement(FieldVisibilityStateContext.Provider, { value: state },
        React.createElement(FieldVisibilityDispatchContext.Provider, { value: dispatch }, children)));
};
const useFieldVisibilityState = () => {
    const context = React.useContext(FieldVisibilityStateContext);
    useWhyDidYouUpdate_1.useWhyDidYouUpdate("useFieldVisibilityState", context);
    return context;
};
const useFieldVisibilityDispatch = () => {
    const context = React.useContext(FieldVisibilityDispatchContext);
    return context;
};
exports.useFieldVisibilityContext = (defaultSettings) => {
    const fieldVis = useFieldVisibilityState();
    const fieldVisDispatch = useFieldVisibilityDispatch();
    React.useEffect(() => {
        if (defaultSettings && fieldVisDispatch) {
            fieldVisDispatch({ type: "update", payload: defaultSettings });
        }
    }, [defaultSettings, fieldVisDispatch]);
    return { fieldVis: defaultSettings || fieldVis, fieldVisDispatch };
};
//# sourceMappingURL=FieldVisibilityContext.js.map